import styled from "@emotion/styled"

export const StyledSlice = styled.div`
  margin: 0 auto;
`

export const StyledSliceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  h3 {
    font-family: ${(p) => p.theme.fontFamilies.headline};
    font-style: ${(p) => p.theme.fontStyles.normal};
    font-weight: ${(p) => p.theme.fontWeights.semiBolder};
    font-size: 1.125rem;
    line-height: 1.5rem;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    color: ${(p) => p.theme.colors.black};
  }

  .link-button-text span {
    font-family: ${(p) => p.theme.fontFamilies.headline};
    font-size: 1rem;
    line-height: 1.5rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    h3 {
      font-size: 1.5rem;
      line-height: 2rem;
    }
    .link-button-text span {
      font-family: ${(p) => p.theme.fontFamilies.headline};
      font-size: 1.25rem;
      line-height: 1.75rem;
    }
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    h3 {
      font-size: 2rem;
      line-height: 2.625rem;
    }
  }
`
